import { css } from "@emotion/css";

import { yellow } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createTasksPageStyles = ({ spacing, breakpoints }: Theme) => {
  return {
    content: css({
      height: "100%",
      display: "flex",
      flexDirection: "column",
    }),
    root: css({
      position: "relative",
      minWidth: 0,
    }),
    heading: css({
      marginBottom: spacing(1),
    }),
    emptyListText: css({
      textAlign: "center",
      marginBottom: spacing(2),
    }),
    loaderWrapper: css({
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: yellow[400],
      width: "100%",
      height: 200,
    }),
    actionsPanel: css({
      display: "flex",
      flexDirection: "column-reverse",
      [breakpoints.up.sm]: {
        flexDirection: "row",
        alignItems: "start",
        justifyContent: "space-between",
      },
    }),
  };
};
